import styled from 'styled-components';
const Row = styled.div `
  display: flex;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
Row.displayName = 'Row';
const AlignStartRow = styled(Row) `
  align-items: flex-start;
`;
AlignStartRow.displayName = 'AlignStartRow';
const AlignCenterRow = styled(Row) `
  align-items: center;
`;
AlignCenterRow.displayName = 'AlignCenterRow';
const AlignEndRow = styled(Row) `
  align-items: flex-end;
`;
AlignEndRow.displayName = 'AlignEndRow';
const PaddedHorizontallyRow = styled(Row) `
  padding-left: ${(props) => props.size || 1}rem;
  padding-right: ${(props) => props.size || 1}rem;
`;
PaddedHorizontallyRow.displayName = 'PaddedHorizontallyRow';
const PaddedVerticallyRow = styled(Row) `
  padding-top: ${(props) => props.size || 1}rem;
  padding-bottom: ${(props) => props.size || 1}rem;
`;
PaddedVerticallyRow.displayName = 'PaddedVerticallyRow';
const Column = styled.div `
  flex: ${(props) => props.flex || 1};
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
Column.displayName = 'Column';
const AlignCenterColumn = styled(Column) `
  text-align: center;
`;
AlignCenterColumn.displayName = 'AlignCenterColumn';
const AlignEndColumn = styled(Column) `
 text-align: end;
`;
AlignEndColumn.displayName = 'AlignEndColumn';
export { Row, AlignStartRow, AlignCenterRow, AlignEndRow, PaddedHorizontallyRow, PaddedVerticallyRow, Column, AlignCenterColumn, AlignEndColumn };
